import { useQuery } from '@tanstack/react-query'
import { getData } from '../../../app/getters/getData.js'

export const useMojeDane = (enabled = true, kcId) =>
    useQuery({
        queryKey: ['moje_dane', kcId],
        queryFn: async () => {
            const data = await getData('/uzytkownik')
            return data?.item || data || {}
        },
        enabled,
        refetchOnMount: false,
    })
